import React from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
  Grid2,
  DialogActions,
} from "@mui/material";
import AppInputField from "../../../components/CommonReusableComponent/AppInputField/AppInputField";
import AppButton from "../../../components/CommonReusableComponent/AppButton/AppButton";
import { useFormik } from "formik";
import * as Yup from "yup";
import { thirdPartyRemarkReasonConfig } from "./ThirdPartyAuditMaster.config";
import { Icons } from "../../../config/MuiIcons.config";
import AppAutoCompleteField from "../../../components/CommonReusableComponent/AppAutoCompleteField/AppAutoCompleteField";

const ThirdPartyRemarksAndReasonModal = ({
  Open,
  ToggleFunction,
  API_Payload = null,
  OnSubmit = () => {},
}) => {
  // Function to handle form reset after update
  const handleFormReset = () => {
    ToggleFunction();
  };

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      remark: "",
      reason: "",
    },
    validationSchema: Yup.object({
      remark: Yup.string().required("Select remark"),
      reason: Yup.string().trim().required("Enter reason"),
    }),
    onSubmit: (values) => {
      const payload = {
        ...values,
        ...API_Payload,
      };
      OnSubmit(payload);
      ToggleFunction();
    },
  });

  return (
    <React.Fragment>
      <Dialog
        open={Open}
        aria-labelledby="form-dialog-title"
        maxWidth="xs"
        fullWidth
        slotProps={{
          style: {
            opacity: 0.7,
          },
        }}
      >
        <DialogTitle id="responsive-dialog-title">
          <div className="d-flex align-items-center">
            <Typography
              className="inter-medium-500"
              style={{
                fontSize: "18px",
              }}
            >
              Add Your Remark
            </Typography>
            <div className="ms-auto"></div>
            <IconButton
              aria-label="close"
              onClick={() => handleFormReset()}
              style={{
                position: "absolute",
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <Icons.Close />
            </IconButton>
          </div>
        </DialogTitle>
        <DialogContent dividers>
          <div>
            <Grid2 container spacing={2} className="mb-3">
              <Grid2 size={12}>
                <Typography variant="body2" className="inter-regular-400 py-1">
                  Select Remark
                </Typography>
                <AppAutoCompleteField
                  IsMultiple={false}
                  Id={"remark"}
                  TextInputId={"remark"}
                  TextInputName={"remark"}
                  TextInputPlaceholder={"Select remark"}
                  HandleOnBlur={validation.handleBlur}
                  HandleOnChange={(event, value) => {
                    if (value?.value) {
                      validation.setFieldValue("remark", value?.value || "");
                    }
                  }}
                  TextInputError={
                      validation.touched.remark &&
                      validation.errors.remark
                        ? true
                        : false
                    }
                  TextInputHelperText={
                      validation.touched.remark &&
                      validation.errors.remark
                        ? validation.errors.remark
                        : null
                    }
                  Options={thirdPartyRemarkReasonConfig || []}
                  Value={validation.values.remark || ""}
                />
              </Grid2>
              <Grid2 size={12}>
                <Typography variant="body2" className="inter-regular-400 py-1">
                  Reason
                </Typography>
                <AppInputField
                  Name={"reason"}
                  Id={"reason"}
                  IsMultiLine={true}
                  MaxRows={4}
                  PlaceHolder={"Enter reason"}
                  Value={validation.values.reason || ""}
                  OnBlur={validation.handleBlur}
                  OnChange={validation.handleChange}
                  Error={
                    validation.touched.reason && validation.errors.reason
                      ? true
                      : false
                  }
                  HelperText={
                    validation.touched.reason && validation.errors.reason
                      ? validation.errors.reason
                      : null
                  }
                />
              </Grid2>
            </Grid2>
          </div>
        </DialogContent>
        <DialogActions>
          <div className="w-100">
            <Grid2 container spacing={1}>
              <Grid2 size={12} className="my-2">
                <AppButton OnPress={() => validation.handleSubmit()}>
                  Submit
                </AppButton>
              </Grid2>
            </Grid2>
          </div>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default ThirdPartyRemarksAndReasonModal;
